import { CludoArrangementsResults } from 'ui/components';

export const CludoArrangementsResultsFeature: React.FC<Umbraco.CludoSearchResults> = ({ content }) => {
	return <CludoArrangementsResults {...content.properties} />;
};
